import {EditorState, SelectionState} from "draft-js";

export function moveFocusToBlockEnd(editorState, contentBlock) {
    return EditorState.forceSelection(editorState, new SelectionState({
        anchorKey: contentBlock.getKey(),
        anchorOffset: contentBlock.getLength(),
        focusKey: contentBlock.getKey(),
        focusOffset: contentBlock.getLength()
    }));
}